import * as d3 from 'd3';
import { ScaleBand, ScaleLinear } from 'd3';
import { ChartDataArray } from '../data/ChartDataArray';
import { StackedRenderer } from './StackedRenderer';

export class StackedAreaRenderer extends StackedRenderer {
  constructor(
    private gElement: d3.Selection<SVGGElement, unknown, null, undefined>,
    filled?: boolean
  ) {
    super(!!filled);
  }

  public render(arrays: ChartDataArray[], x: ScaleBand<string>, y: ScaleLinear<number, number>) {
    const keys = StackedRenderer.getKeys(arrays);
    const series = super.createSeries(arrays, keys);

    this.gElement
      .selectAll('.fill-stacked-areas')
      .data([series])
      .enter()
      .append('g')
      .attr('class', 'fill-stacked-areas')
      .selectAll('fill-stacked-area')
      .data(d => d)
      .enter()
      .append('path')
      .attr('class', (_d, i) => `fill-stacked-area chart-color-${series.length - i - 1}`)
      .style('fill', (_d, i) => arrays[series.length - i - 1].color || '')
      .attr('d', data => {
        const area = d3
          .area()
          .x((_d, i) => {
            const xKey: string = keys[i];
            return (x(xKey) || 0) + x.bandwidth() / 2;
          })
          .y0(d => y(d[0]))
          .y1(d => y(!Number.isNaN(d[1]) ? d[1] : 0));
        // @ts-ignore
        return area(data);
      });

    // move the hilight-lines node to the bottom of the DOM so that the lines overlay the area chart
    const node: HTMLElement = this.gElement.select('.highlight-lines').node() as HTMLElement;
    node.parentElement!.appendChild(node);
  }

  switchHighlight(): void {
    // nothing to do here
  }
}
